import { Component, OnInit } from '@angular/core';
import { JwtService } from 'src/app/jwt.service';
import { MensagemMural } from 'src/app/persistences/mensagem-mural';
import { MuralService } from 'src/app/services/mural.service';

@Component({
  standalone: false,
  selector: 'app-mural-avisos',
  templateUrl: './mural-avisos.component.html',
  styleUrls: ['./mural-avisos.component.css']
})
export class MuralAvisosComponent implements OnInit{
  mensagensMural: MensagemMural[];

  constructor(
    private muralService: MuralService,
    private jwtService: JwtService
  ){}

  ngOnInit(): void {
    this.jwtService.checkLogin();
    this.muralService.getMensagensMural().subscribe((mensagens)=>{
      this.mensagensMural = mensagens;
    })
  }

  abrirMensagem(mensagem: MensagemMural){
    if(mensagem.dt_hr_leitura === null){
      this.muralService.atualizaMensagemLida(mensagem.id).subscribe(
        response => {
          this.muralService.getMensagensMural().subscribe((mensagens)=>{
            this.mensagensMural = mensagens;
          });
        },
        error => {
          console.error('Erro ao atualizar mensagem:', error);
        }
      );
    }
  }
}
